export default "__VITE_ASSET__BkCdEX9W__"